// extracted by mini-css-extract-plugin
export default {"wrapper":"TableFilters_wrapper__ftsFo","filterCheckbox":"TableFilters_filterCheckbox__tqlky"};